
<template>   
    <div>
        <v-card>
            <v-card-title>
                <h2>
                    OAuth Clients                    
                </h2>                                                        
            </v-card-title>

            <v-card-text>
                
                <v-layout row>
                    <v-flex xs12>
                        <v-btn v-on:click.native.stop="showCreateClientForm">
                            Create New Client
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <p class="mb-0 mt-2" v-if="clients.length === 0">
                            You have not created any Clients.
                        </p>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs6 offset-xs6>
                        <v-text-field
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                            v-model="tsearch"
                            >

                        </v-text-field>
                    </v-flex>
                </v-layout>
                <!-- Personal Access Tokens -->
                <v-data-table 
                    v-if="clients.length > 0"
                    v-bind:headers="headers"
                    v-bind:items="clients"
                    v-bind:search="tsearch"
                    select-all
                    v-bind:pagination.sync="pagination"
                    item-key="id"
                    class="elevation-0"
                    >
                
                    <template slot="headers" slot-scope="props">
                   
                        <tr>
                            
                            <th 
                                align="left"
                                v-for="header in props.headers" 
                                :key="header.text"
                                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                @click="changeSort(header.value)"
                            >
                            <v-icon>arrow_upward</v-icon>
                                {{ header.text }}
                            </th>
                            <th></th>
                            <th></th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr>                                                        
                            
                            <td>
                                {{ props.item.id }}
                            </td>
                            <td>
                                {{ props.item.name }}
                            </td>
                            <td>
                                <code>{{ props.item.secret }}</code>
                            </td>
                            
                            <td>
                                <v-btn small class="success" v-on:click.native.stop="edit(props.item)">
                                    Edit
                                </v-btn>
                           
                                <v-btn small class="error" v-on:click.native.stop="destroy(props.item)">
                                    Delete
                                </v-btn>
                            </td>
                        </tr>
                    </template>                   
                </v-data-table>                
                
            </v-card-text>
        </v-card>

        <v-dialog v-model="dialog1" lazy absolute>    
            <v-card>
                <v-card-title>
                    <div class="headline">Create Client</div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout row v-for="error in createForm.errors" :key="error.id">
                            <v-flex xs12>
                                {{ error }}
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    hint="Something your users will recognize and trust."
                                    id="create-client-name"
                                    v-model="createForm.name">

                                </v-text-field>                                                        
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    label="Redirect URL"
                                    name="redirect"
                                    hint="Your application's authorization callback URL."
                                    id="create-client-redirect"
                                    v-model="createForm.redirect">

                                </v-text-field>                                                        
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="dialog1 = false">Close</v-btn>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="store">Create</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialog2" lazy absolute>    
            <v-card>
                <v-card-title>
                    <div class="headline">Edit Client</div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    hint="Something your users will recognize and trust."
                                    id="edit-client-name"
                                    v-model="editForm.name">

                                </v-text-field>                                                        
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    label="Redirect URL"
                                    name="redirect"
                                    hint="Your application's authorization callback URL."
                                    id="edit-client-redirect"
                                    v-model="editForm.redirect">

                                </v-text-field>                                                        
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="dialog2 = false">Close</v-btn>
                    <v-btn class="green--text darken-1" flat="flat" v-on:click.native.stop="update">Save Changes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        

    </div>
</template>

<script>
   
    export default {
        /*
         * The component's data.
         */
        data() {
            return {
                
                pagination: {
                sortBy: 'name'
                },
                tsearch:'',
                headers: [
                    {text: 'Id', align: 'left', value: 'id'},
                    {text: 'Name', align: 'left', value: 'name'},
                    {text: 'Secret', align: 'left', value: 'secret'},

                ],
                clients: [],
                dialog1: false,
                dialog2: false,

                createForm: {
                    errors: [],
                    name: '',
                    redirect: ''
                },

                editForm: {
                    errors: [],
                    name: '',
                    redirect: ''
                }
            };
        },

        

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },

        methods: {
            
            /**
             * Data table methods.
             */          
            changeSort (column) {
                if (this.pagination.sortBy === column) {
                  this.pagination.descending = !this.pagination.descending
                } else {
                  this.pagination.sortBy = column
                  this.pagination.descending = false
                }              
            },
            
            /**
             * Prepare the component.
             */
            prepareComponent() {
                this.getClients();                
            },

            /**
             * Get all of the OAuth clients for the user.
             */
            getClients() {
                this.$store.dispatch('getAPIClients').then((response)=>{ 
                    this.clients = response.data;
                })
            },

            /**
             * Show the form for creating new clients.
             */
            showCreateClientForm() {
                this.dialog1=true;
            },

            /**
             * Create a new OAuth client for the user.
             */
            store() {
                this.createForm.errors = [];
                
                this.$store.dispatch('postAPIClients', this.createForm)
                    .then((response)=>{ 
                        this.updateForm(this.createForm)
                    })                      
                
            },

            /**
             * Edit the given client.
             */
            edit(client) {
                this.editForm.id = client.id;
                this.editForm.name = client.name;
                this.editForm.redirect = client.redirect;

                this.dialog2=true;
            },

            /**
             * Update the client being edited.
             */
            update() {
                this.editForm.errors = [];
                this.$store.dispatch('putAPIClients', this.editForm.id)
                    .then((response)=>{ 
                        this.updateForm(this.editForm)
                    })                      
                
            },

            /**
             * Persist the client to storage using the given form.
             */
            updateForm(form) {
               
                    this.getClients();
                    form.name = '';
                    form.redirect = '';
                    form.errors = [];
                    this.dialog1=false;
                    this.dialog2=false;
                                  
            },

            /**
             * Destroy the given client.
             */
            destroy(client) {
                
                this.$store.dispatch('destroyAPIClients', client.id)
                    .then((response)=>{ 
                        this.getClients();
                    })               
                }
        }
    }
</script>



// WEBPACK FOOTER //
// Clients.vue?1bbfb7ca